import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import GlobalSearch from './GlobalSearch';

const links = [
  { to: '/', label: '首页' },
  { to: '/movies', label: '电影' },
  { to: '/news', label: '资讯' },
  { to: '/about', label: '关于' },
  { to: '/contact', label: '联系' },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 text-sm font-medium rounded-md transition-colors whitespace-nowrap ${
      isActive
        ? 'text-primary-600 bg-primary-50'
        : 'text-foreground-700 hover:text-primary-600 hover:bg-background-100'
    }`;

  return (
    <header className="sticky top-0 z-40 bg-background-50/95 backdrop-blur border-b border-background-200">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="h-16 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-movie-2-fill text-lg"></i>
            </span>
            <span className="brand-font text-lg md:text-xl text-foreground-950 leading-none">
              聚会的目的电影
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1 flex-1 justify-center" aria-label="主导航">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} className={linkClass} end={l.to === '/'}>
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden md:block w-56 lg:w-64 shrink-0">
            <GlobalSearch />
          </div>

          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="打开菜单"
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
          >
            <i className={mobileOpen ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <div className="px-4 py-4 space-y-3">
            <GlobalSearch variant="mobile" onNavigate={() => setMobileOpen(false)} />
            <nav className="flex flex-col" aria-label="移动端导航">
              {links.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === '/'}
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `px-3 py-3 rounded-md text-base font-medium transition-colors ${
                      isActive
                        ? 'text-primary-600 bg-primary-50'
                        : 'text-foreground-800 hover:bg-background-100'
                    }`
                  }
                >
                  {l.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}